<template>
    <div>
        <el-dialog
        :title="dialogTitle"
        width="600px"
        center
        :show-close = "false"
        :fullscreen="isFullscreen"
        :visible.sync="dialogVisible"
        :class="{isFullscreenClass:isFullscreen}">
        <span slot="title" class="dialog-title">
            <span>Repost&nbsp;to&nbsp;Facebook</span>
        </span>
        <div class="main">
            <div class="avatar">
                <div class="avatar_img">
                    <el-avatar size="large " :src="circleUrl" ></el-avatar>
                </div>
                <div class="avatar_message">
                    <div class="avatar_name">
                        Peibei
                    </div>
                    <div class="avatar_label">
                        <div class="avatar_label_item">
                            动态
                        </div>
                        <div class="avatar_label_item">
                          <i class="el-icon-s-custom"></i> 好友<i class="el-icon-caret-bottom" style="margin-left: 1px;"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input_box">
              <el-input
                  type="textarea"
                  :rows="3"
                  placeholder="Say something..."
                  v-model="textarea">
                </el-input>
            </div>
            <div class="share_button_box">
              <el-button size="small" color="rgba(45, 82, 208, 1)" style="background-color:rgba(45, 82, 208, 1);color: aliceblue;float: right;;">Share Now</el-button>
            </div>
        </div>
        <div class="divide_box flex-col"></div>
        <div class="share_box">
          <div class="share_title">分享到</div>
            <div class="share_friend">
              <div class="share_friend_item" v-for="(item,index) in shareUserList" :key="index">
                <el-avatar size="large " :src="item.url" style="margin-left: 20%;"></el-avatar>
              </div>
            </div>

        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="resetForm" size="small" round style="width: 100px;margin-right: 10px;background-color:rgba(249, 249, 249, 1);font-family: SourceHanSansCN-Regular;color: rgba(110, 110, 115, 1);">Cancel</el-button>
            <el-button  @click="submitForm" size="small" round style="width: 100px;margin-left: 10px;background-color:rgba(249, 249, 249, 1);font-family: SourceHanSansCN-Regular;color: rgba(110, 110, 115, 1);">Repost</el-button>
        </span>
        </el-dialog>
        <!-- <imageSingleViewDialog ref="imageSingleViewDialog"></imageSingleViewDialog> -->
    </div>
</template>

  <script>
    // import {addDevice,editDevice} from '@/api/device'
    // import imageSingleViewDialog from '@/components/viewDialog/imageSingleViewDialog'

    export default {
    //   dicts: ['device_type','device_status'],
      components: {
        // imageSingleViewDialog,
       },
      data() {
        var timeCheck=(rule,value,callback)=>{
          if(this.scheduling[0]==undefined||this.scheduling[1]==undefined){
            return callback(new Error('排班起始时间不能为空'));
          }else{
            callback()
          }
        }
        // var validatePass = (rule, value, callback) => {
        // 	let arr = this.$refs.deptTree.getCheckedKeys(); // 在此获取选中的树形数据
        // 	if (arr.length == 0 || !arr) {
        // 		callback(new Error("请选择功能权限设置"));
        // 	} else {
        // 		callback();
        // 	}
        // };
        return {
          circleUrl:'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
          shareUserList:[
            {
              name:'yoyo',
              url:require('@/components/aboutUs/imgs/friend1.jpeg'),
            },
            {
              name:'xinxin',
              url:require('@/components/aboutUs/imgs/friend2.jpeg'),
            },
            {
              name:'xinxin',
              url:require('@/components/aboutUs/imgs/friend3.jpeg'),
            },
            {
              name:'xinxin',
              url:require('@/components/aboutUs/imgs/friend4.jpeg'),
            },
            {
              name:'xinxin',
              url:require('@/components/aboutUs/imgs/friend5.jpeg'),
            },
          ],
          fileList:[],
          fileList2:[],
          activeNames:['1','2'],    //折叠面板展开
          uploadUrl:'/guandao/minio/uploadFile',
          headerToken:{
            "token":sessionStorage.getItem("token")
          },
          isFullscreen:false,//是否全屏展示
          // 表单数据
          form:{},
          // 是否显示弹框
          dialogVisible:false,
          // 弹框标题
          dialogTitle:'',
          // 部门信息树
          deptTreeData:[],
          // 角色信息
          roleData:[],
          // 权限范围
          dataScopeOption:[
            {
              value:'1',
              label:'全部数据权限'
            },
            {
              value:'2',
              label:'自定数据权限'
            },
            {
              value:'3',
              label:'本部门数据权限'
            },
            {
              value:'4',
              label:'本部门及以下数据权限'
            },
          ],
          // 性别
          sexOption:[
            {
              value:'0',
              label:'女'
            },
            {
              value:'1',
              label:'男'
            },
          ],
          // 状态
          statusOption:[
            {
              value:'0',
              label:'正常'
            },
            {
              value:'1',
              label:'异常'
            },
          ],
          isOption:[
            {
              value:0,
              label:'否'
            },
            {
              value:1,
              label:'是'
            },
          ],

          //排班日期数组
          scheduling:[],
          //照片文件列表
          fileList1:[],
          //行驶证照片文件列表
          fileList2:[],
          // 表单校验
          rules: {
            deviceName: [
              { required: true, message: '请输入设备名称', trigger: 'blur' },
            ],
            iccId: [
              { required: true, message: '请输入设备ICCID', trigger: 'blur' },
            ],
            deviceModel: [
              { required: true, message: '请输入设备型号', trigger: 'blur' },
            ],
            macAddress: [
              { required: true, message: '请输入设备MAC地址', trigger: 'blur' },
            ],
            ipAddress: [
              { required: true, message: '请输入IP地址', trigger: 'blur' },
            ],
            maintainer: [
              { required: true, message: '请输入管径', trigger: 'blur' },
            ],
            location: [
              { required: true, message: '请输入设备维修人员', trigger: 'blur' },
            ],
            coordinate: [
              { required: true, message: '请输入设备安装坐标', trigger: 'blur' },
            ],
            companyName: [
              { required: true, message: '请输入设备所属企业名称', trigger: 'blur' },
            ],
            deviceType: [
              { required: true,message: '请选择设备类型', trigger: "change" }
            ],
            deviceStatus: [
              { required: true,message: '请选择设备状态', trigger: "change" }
            ],
            contact: [
              { required: true, message: '请输入联系方式', trigger: 'blur' },
              {pattern:/(^((\+86)|(86))?(1[3-9])\d{9}$)|(^(0\d{2,3})-?(\d{7,8})$)/,message: '手机号码格式不正确，请重新输入',trigger:'blur'}
            ],
            scheduling2: [
              {validator:timeCheck,trigger:'blur', required: true,}
            ],
            reportDate: [
              { required: true, message: '请选择上报日期', trigger: 'change' },
            ],
            driverTelephone:[
            {pattern:/(^((\+86)|(86))?(1[3-9])\d{9}$)|(^(0\d{2,3})-?(\d{7,8})$)/,message: '手机号码格式不正确，请重新输入',trigger:'blur'}
            ],
            licensePlate: [
              { required: true, message: '请输入车牌号', trigger: 'blur' },
            ],
            deptId: [
              { required: true,message: '请选择归属部门', trigger: "change" }
            ],
            phonenumber: [
              { required: true, message: '请输入电话号码', trigger: 'blur' },
              {pattern:/(^((\+86)|(86))?(1[3-9])\d{9}$)|(^(0\d{2,3})-?(\d{7,8})$)/,message: '手机号码格式不正确，请重新输入',trigger:'blur'}
            ],
            email: [
              { required: true, message: '请输入邮箱', trigger: 'blur' },
              {pattern:/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9_\.\-])+\.)+([a-zA-Z0-9]{2,4})+$/,message:'请输入正确的邮箱格式',trigger:'blur'}
            ],
            userName: [
              { required: true, message: '请输入用户名称', trigger: 'blur' },
            ],
            password: [
              { required: true, message: '请输入用户密码', trigger: 'blur' },
              {pattern:/^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-z]|[A-Z]|[0-9]){6,16}$/,message:'密码必须包含数字、字母、特殊符号任意两种组合,长度为6-16位',trigger:'blur'}
            ],
            sex: [
              { required: true, message: '请选择性别', trigger: 'change' },
            ],
            status: [
              { required: true, message: '请选择状态', trigger: 'change' },
            ],
          }
        }
      },
      mounted(){
      },
      methods: {
        /* 初始化*/
        open(dialogTitle,form){
          this.reset()
          this.scheduling = []
          this.fileList = []
          this.dialogTitle = dialogTitle
          if(form && form.id){
            this.form = form
            if(this.form.devicePicture!= null &&  this.form.devicePicture != ''){
                this.fileList = JSON.parse(this.form.devicePicture)
                // list.forEach(item=>{
                //     this.fileList.push({url:item})
                // })
            }
            setTimeout(() => {
                this.dialogVisible = true
            }, 600);

            // if(this.form.licenseFileName!= null && this.form.drivingLicense != null && this.form.licenseFileName != '' && this.form.drivingLicense != ''){
            //   this.fileList2.push({name:this.form.licenseFileName,url:this.form.drivingLicense})
            // }
          }else{
            this.dialogVisible = true
          }
        //   else{
        //     this.form.inspectionDate = form.inspectionDate
        //     this.form.schedulingId = form.schedulingId
        //   }
        },
        /**排班时间选择*/
        timeChange(value){
          this.form.startTime = value[0]
          this.form.endTime = value[1]
        },

        /* 提交表单*/
        submitForm(){
          this.$refs.form.validate((valid)=>{
            if(valid){
              this.form.deviceJson = null
                // if(this.fileList.length != 0){
                //     this.form.evidence = ""
                //     this.fileList.forEach((item,index)=>{
                //         if(index == 0){
                //             this.form.evidence = item.url
                //         }else{
                //             this.form.evidence = this.form.evidence + ',' +item.url
                //         }
                //     })
                // }
                if(this.fileList.length != 0){
                  this.form.devicePicture = JSON.stringify(this.fileList)
                }
              if(this.form.id){
                editDevice(this.form).then(res=>{
                  if(res.code === 200){
                    this.dialogVisible = false
                    this.$message.success("修改管道登记信息成功！")
                    this.$parent.getData()
                  }else{
                    this.$message.error("修改管道登记信息失败！")
                  }
                })
              }else {
                addDevice(this.form).then(res=>{
                    if(res.code === 200){
                      this.dialogVisible = false
                      this.$message.success("添加管道登记信息成功！")
                      this.$parent.getData()
                    }else{
                      this.$message.error("添加管道登记信息失败！")
                    }
                  })
              }
            }else{
              this.$message("请完整填写信息！")
            }
          })
        },
        /**日期格式化 */
        formatDate(date) {
          // 格式化日期为YYYY-MM-DD字符串
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const day = date.getDate().toString().padStart(2, '0');
          return `${year}-${month}-${day}`;
        },
        // 表单重置
        reset() {
          this.isFullscreen = false
          this.form = {
            userName: undefined,
            nickName: undefined,
            phonenumber: undefined,
            deptId: undefined,
            sex: undefined,
            // status: '0',
            remark: undefined,
            role:undefined,
          };
          if(this.$refs.form){
            this.$refs.form.resetFields();
          }
        },
        /* 关闭弹框方法*/
        resetForm(){
          this.dialogVisible = false
          this.handleClose()
          this.reset()
        },
        /* 关闭弹框*/
        handleClose(){
          if(this.isFullscreen){
            closePopUp()
          }
        },
        //文件地址和文件名回传
        onSuccess(response,file,fileList){
            // this.fileList = fileList;
            // this.form.carFileName = file.name
            // this.form.carPhoto = file.
            this.fileList.push({url:file.response});
            // this.fileNameList.push(file.name)
            // this.fileUrlList.push(file.response)
        },
        /**上传文件列表变化*/
        onChange(file,fileList){
          // this.form.fileName.push(res[0])
          // this.form.fileUrl.push(res[1])
          // this.fileList.forEach(item=>{
          //         let formData = new FormData ()
          //         formData.append("file",item.raw)
          //         uploadFile(formData).then(res=>{
          //           this.form.fileName.push(res[0])
          //           this.form.fileUrl.push(res[1])
          //           console.log("res[0]",res[0])
          //           console.log("res[1]",res[1])

          //           })
          //       })
        },
        //移除文件时的钩子
        onRemove(file,fileList){
          //多个文件移除一个文件方法
        //   this.fileList.forEach((item,index)=>{
        //     if(item.uid == file.uid){
        //       this.form.fileName.splice(index,1)
        //       this.form.fileUrl.splice(index,1)
        //     }
        //   })
          this.fileList = fileList
          //在只有一个文件的情况下移除方法
        //   this.fileList = []
        //   this.form.carFileName = ''
        //   this.form.carPhoto = ''
        },
        /**上传前文件类型限制 */
        beforeUpload(file){
          const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
          const fileTypeList = ['jpg','jpeg','png','gif']
          if (fileTypeList.indexOf(fileSuffix) === -1) {
            this.$message.error('上传文件只能是 jpg,jpeg,png,gif格式');
            return false;
          }
        },
        /**下载附件文件*/
        downloadFile(item,index){
          // console.log("this.form.fileUrl[index]",this.form.fileUrl[index])
          window.open(this.form.fileUrl[index], '_blank' );
        },
        /**文件列表限制 */
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            // this.$message.warning(`当前限制选择 1 个文件，请将所选列表文件清空再进行重新上传`);
        },
        /**预览图片*/
        viewImage(item){
          this.$refs.imageSingleViewDialog.open('图片预览',item.url)
        },
      }
    }
  </script>

  <style scoped>
    .isFullscreenClass .el-dialog__body{
      max-height: 80vh !important;
    }
    .dialog-title{
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        line-height: 40px;

    }
  @media only screen and (min-width: 800px){
    .main{
        width: 100%;

    }
  }
    .avatar{
            width: 100%;
            height: 50px;
        }
    .avatar_img{
        float: left;
        height: 100%;
    }
    .avatar_message{
        float: left;
        height: 100%;
        margin-left: 5px;
    }
    .avatar_name{
        height: 40%;
        color: rgba(51, 51, 51, 1);
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }
    .avatar_label{
        height: 60%;
    }
    .avatar_label_item{
        float: left;
        height:22px;
        /* width:40px; */
        padding: 2px 5px;
        margin-right: 5px;
        background-color: rgba(240, 245, 255, 1);
        border-radius: 6px;
        color: rgba(51, 51, 51, 1);
        font-size: 10px;
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        text-align: center;
        line-height: 18px;
    }
    .input_box{
      min-height: 80px;
    }
    .share_button_box{
      width: 100%;
      height: 30px;
      margin-top: 8px;
    }
    .divide_box {
        background-color: rgba(240, 242, 245, 1);
        width: 100%;
        height: 1px;
        margin: 15px 0 10px 0;
    }
    .share_box{
      width: 100%;
      height: 100px;
    }
    .share_title{
      width: 100%;
      height: 10%;
      color: rgba(51, 51, 51, 1);
      font-size: 18px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      text-align: left;
      white-space: nowrap;
      line-height: 36px;
    }
    .share_friend{
      width: 80%;
      height: 50px;
      padding-top: 40px;
      margin:0 auto;
    }
    .share_friend_item{
      float: left;
      width: 20%;
    }
  </style>



// WEBPACK FOOTER //
// src/components/whatWeDo/subcomponents/shareDialog.vue